// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1XIoz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__9zohz"};